import { useAppSelector } from '@redux/hooks';
import { FilterTemplates, getAuto, getTemplate } from '@entities/Filter';
import { useHasSensorQuery } from '@entities/Auto';
import { Part } from '@entities/Product';
import { selectRegion } from '@redux/slices/header';
import { Region } from '@enums/RegionList';

const SENSOR_RN = 118937772559;
const SENSOR_ID = 139242;
const QTY = 1;

const RegionList = [Region.Moscow, Region.OrekhovoZuevo];

export const useAddSensor = (isSkip?: boolean) => {
  const { modification } = useAppSelector(getAuto);
  const { REGION: regionId } = useAppSelector(selectRegion);
  const template = useAppSelector(getTemplate);
  const { data, isFetching } = useHasSensorQuery(
    {
      modificationId: modification?.id,
    },
    {
      skip: !modification || FilterTemplates.DisksAuto !== template || !RegionList.includes(+regionId) || isSkip,
    },
  );

  return {
    isSensor: data && !!modification && FilterTemplates.DisksAuto === template,
    isFetching,
    sensorData: {
      rn: SENSOR_RN,
      part: Part.RelatedProducts,
      productId: SENSOR_ID,
      qty: QTY,
    },
  };
};
